import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatSelect } from "@angular/material/select";
import { ApiService } from "app/api.service";
import { AdminService } from "app/admin.service";
import { CreateProductViewDialogComponent } from "app/create-product-view-dialog/create-product-view-dialog.component";
import { ApprovalTimelineDialogComponent } from 'app/components/approval-timeline/approval-timeline-dialog.component';
import { HsnGstEditComponent } from '../hsn-gst-edit/hsn-gst-edit.component';
import { VoucherFileModalComponent } from 'app/voucher-file-modal/voucher-file-modal.component';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UiUnsavedChangesDialogComponent, UnsavedChangesResult } from 'app/shared/ui/document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';
import { UI_DOCUMENT_PANEL_BREADCRUMBS } from 'app/shared/ui/document-panel/document-panel.config';

@Component({
  selector: "app-sales-voucher",
  templateUrl: "./sales-voucher.component.html",
  styleUrls: ["./sales-voucher.component.scss"],
  host: { class: 'ui-document-panel-host' },
})
export class SalesVoucherComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<SalesVoucherComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) { }

  // Voucher
  voucherType: any;
  voucher_type: any;
  voucherNo: any;
  operationType: any;
  type: any;
  vouchers: any[] = [];
  isUpdate = false;
  isView = false;
  isPurchase = false;
  isSales = true;
  showPostButton = false;
  approval_status: any = null;
  isLoadingVoucher = false;
  panelMode: UiPanelMode = 'create';
  enteredEditFromView = false;
  editSnapshot: string | null = null;
  readonly breadcrumb = UI_DOCUMENT_PANEL_BREADCRUMBS.salesVoucher;
  @ViewChild('ledgerSelect') ledgerSelect!: MatSelect;
  // Host
  hostname = "";
  fullhostname = "";
  // Branch
  branch: any;
  branchdata: any[] = [];
  branch_access_list: any;
  // Customer
  customer: any;
  customers: any;
  customerData: any[] = [];
  // Customer Branch
  customerBranchData: any[] = [];
  selectedCustomerBranch: any;
  customerBranchdetails: any;
  cutomer_branchs: any;
  customerBranchLedger: any;
  // Profit Cost
  ProfitCostData: any[] = [];
  profitCostId!: number[];
  profit_cost: any[] = [];
  // Sales Invoice
  salesInvoice: any;
  sales_invoice: any[] = [];
  sales_invoice_details: any[] = [];
  // Section
  sectionData: any[] = [];
  all_section_data: any[] = [];
  filteredSections: any[] = [];
  selectedSection: any[] = [];
  section_selected: any;
  // GSSN
  gsn: any[] = [];
  selectedGsn: any[] = [];
  // Product
  productEntries: any[] = [];
  productList: any[] = [];
  combinedDropdownData: any[] = [];
  selectedItem: any;
  selectedQty: any;
  selectedUnitPrice: any;
  selectedDiscount: any;
  selectedTaxType: any;
  selectedDescription: any;
  unit: any;
  hsn_no: any;
  //Store
  store_id_for_items: any;
  store_data: any;
  // Ledger
  rounded_ledger_data: any[] = [];
  ledger: any;
  // GST
  tax: any[] = [];
  vendorBranchGstType: any;
  // Document
  document_no: any;
  issue_date: any;
  date: any;
  maxDate: any;
  // Narration
  purchesnarration: any;
  // Upload
  myFiles: any[] = [];
  // Totals
  roundedamount = 0;
  roundedamount2 = 0;
  debitEntries: any[] = [];
  creditEntries: any[] = [];
  details: any[] = [];
  fa_details: any[] = [];
  fa_master: any[] = [];
  invoice_type: string = 'sales';
  existingFiles: any[] = [];
  image_data: any[] = [];
  originalVoucherId: any;
  // Flags
  is_pi_si_manual: any;
  selectedEmployees: any[] = [];
  profit_cost_id: any[] = [];
  //Company Details
  company_name: string;
  company_email: string;
  company_phone: string;
  company_address: string;
  company_gstno: string;
  company_pan: string;
  company_logo: string;
  company_signature: string;
  company_cin: any;
  price_policy: any;
  //Employee Details
  employee_data: any[] = [];
  employee_name: any;
  employee_id: any;
  employee_designation: any;
  employee_department: any;
  employee_branch: any;
  employee_section: any;
  //Customer Details
  customer_name: any;
  customer_email: any;
  customer_phone: any;
  customer_address: any;
  customer_address1: any;
  customer_district: any;
  customer_pincode: any;
  customer_city: any;
  customer_pan: any;
  customer_branch_gst: any;
  customer_branch_address: any;
  customer_branch_address1: any;
  customer_branch_city: any;
  customer_branch_pincode: any;
  customer_branch_district: any;
  customer_branch_name: any;
  customer_branch_state: any;
  customer_branch_tan_no: any;
  customer_branch_cin_no: any;
  vendorBranchGstNumber: any;
  unit_name: any;
  invoice_date: any;
  cutomer_branch_ledger_id: any;
  cutomer_branch_ledger_name: any;
  uploadedFiles: any[] = [];
  is_posted: any;
  ledger_ids: any;
  currentSearch = "";
  is_sku = false;
  is_service = false;
  is_fixed_asset = false;
  hasMore = true;
  limit = 50;
  loading = false;
  voucher_data: any;
  selectedGrn: any[] = [];
  ledger_name: string;
  ledger_id: any;
  ngOnInit(): void {
    console.log("Sales Voucher", this.data);

    this.operationType = this.data.operationType || this.data.type || 'create';
    this.type = this.operationType;
    this.voucherType = this.data.voucherType;
    this.voucher_type = this.data.voucherName || "Sales";
    this.showPostButton = !!this.data.showPostButton;
    if (this.data.approval_status !== undefined) {
      this.approval_status = this.data.approval_status;
    }

    this.isUpdate = this.operationType === "update";
    this.isView = this.operationType === "view";
    this.initPanelMode();

    this.hostname = window.location.hostname;
    this.fullhostname = window.location.origin;

    const today = new Date();

    this.date = this.formatDate(today);
    this.maxDate = this.formatDate(today);

    this.fetchcompany(this.hostname);
    this.fetchbranchData();
    this.fetchSectionData();
    this.fetchEmployeeData();
    this.fetchVoucherData();
    this.fetchtaxData();

    if (this.data.id) {
      this.fetchVoucherById();
    }

    if (this.panelMode === 'edit') {
      this.editSnapshot = this.captureEditSnapshot();
    }
  }

  formatDate(date: Date): string {
    return date.toISOString().split("T")[0];
  }
  fetchcompany(data: any) {
    this.apiService.Companydetails(data).subscribe(
      (response) => {
        console.log("company_details", response);
        this.company_name = response.name;
        this.company_email = response.email;
        this.company_phone = response.phone_no;
        this.company_address = response.address;
        this.company_gstno = response.gst_reg_no;
        this.company_pan = response.pan_no;
        this.company_cin = response.cin_no;
        this.company_logo = response.company_logo
          ? `${this.fullhostname}/api/storage/uploads/${response.company_logo}`
          : "";
        this.company_signature = response.company_signature
          ? `${this.fullhostname}/api/storage/uploads/${response.company_signature}`
          : "";
        this.price_policy = response.is_price_policy;
        this.is_pi_si_manual = response.is_pi_si_manual;
        console.log("is_pi_si_manual", this.is_pi_si_manual);
        console.log("company logo", this.company_logo);
        console.log("company signature", this.company_signature);
      },
      (error) => {
        console.error("Error fetching  companydata:", error);
      },
    );
  }
  onBranchChange() {
    this.customer = [];
    this.selectedCustomerBranch = [];
    this.ProfitCostData = [];

    if (this.branch) {
      const type = this.voucher_type == "Sales" ? "customer" : null;
      if (type) {
        this.apiService
          .getVendorCustomerByBranch(this.branch, type)
          .subscribe(
            (data) =>
            (this.customerData = Array.isArray(data?.customer)
              ? data.customer.filter(
                (c) =>
                  Array.isArray(c.customer_branch) &&
                  c.customer_branch.length > 0,
              )
              : []),
          );
      }
    }
    this.fetchProfitCostData();
  }
  onBranchChangeWithLedger(branchId: any) {
    this.onBranchChange();
  }
  fetchVoucherById() {
    this.isLoadingVoucher = true;
    this.apiService.getvoucherPostingById(this.data.id).subscribe(
      (voucherData) => {
        console.log('Else branch API approval_status:', voucherData);
        if (voucherData && voucherData.Voucher) {
          this.voucherType = voucherData.Voucher.voucher_id;
          this.voucherNo = voucherData.Voucher.voucher_no;
          this.date = voucherData.Voucher.date;
          const fetchedStatus = voucherData.Voucher.approval_status;
          if (fetchedStatus !== undefined && fetchedStatus !== null) {
            this.data.approval_status = fetchedStatus;
            this.approval_status = fetchedStatus;
          } else if (this.data.approval_status == null) {
            this.data.approval_status = null;
            this.approval_status = null;
          }
          this.fetchbranchData();
          this.branch = voucherData.Voucher.branch_id;
          this.is_posted = voucherData.Voucher.is_posted;
          this.onBranchChange();
          // this.profit_cost_id = voucherData.Voucher?.creation_voucher_details?.[0]?.profit_cost_id || null;
          this.profit_cost_id = voucherData.Voucher?.profit_cost_id
            ? voucherData.Voucher.profit_cost_id.split(',').map(id => +id)
            : [];
          this.issue_date = voucherData.Voucher.issue_date;
          this.document_no = voucherData.Voucher.document_no;
          this.purchesnarration = voucherData.Voucher.narration;
          if (voucherData.Voucher.creation_voucher_details && voucherData.Voucher.creation_voucher_details?.length > 0) {
            this.productEntries = voucherData.Voucher.creation_voucher_details.map(entry => ({
              // productType: entry.product_id,
              productType: { id: entry.product_id, name: entry.name },
              ledger_name: entry.product_ledger_name,
              ledger_id: entry.product_ledger,
              hsn_no: entry.hsn_no,
              description: entry.description,
              unit: entry.unit_name,
              qty: entry.qty,
              unitPrice: entry.unit_price,
              value: entry.qty * entry.unit_price,
              discount: entry.discount,
              taxType: entry.gst_id,
              customer: entry.vendor_id,
              selectedCustomerBranch: entry.branch_id,
              roundedamount: entry.rounded_amount,
              ledger: entry.rounded_ledger,
              taxledger: this.fetchtaxData(),
              selectedGsn: entry.gsn_id,
              grn_gsn_details_id: entry.grn_gsn_details_id,
              selectedSection: entry.section_id,
              profit_cost_id: entry.profit_cost_id,
            }));
            this.ledger_ids = voucherData.Voucher?.creation_voucher_details?.[0]?.rounded_ledger || null;
            this.onProfitCost(this.profit_cost_id);
            console.log('productEntries of sales', this.productEntries);
            if (this.productEntries?.length > 0) {
              const firstEntry = this.productEntries[0];
              this.apiService.getVendorCustomerByBranch(this.branch, 'customer').subscribe((customers) => {
                this.customerData = Array.isArray(customers?.customer) ? customers.customer : []
              });
              this.customer = firstEntry.customer;
              this.getCustomerBranch(this.customer);
              this.selectedCustomerBranch = this.productEntries[0].selectedCustomerBranch;
              this.section_selected = voucherData.Voucher?.section_id
                ? voucherData.Voucher.section_id.toString().split(',').map(id => +id)
                : [];
              this.selectedSection = this.section_selected;
              console.log('section_selected sales', this.section_selected);
              this.fetchGsn();
              this.selectedGsn = [...new Set(this.productEntries.map(entry => entry.selectedGsn))];
              this.CustomerBranchdetails(this.selectedCustomerBranch);
              if (this.selectedGsn?.some(gsn => gsn !== null)) {
                this.roundedamount2 = firstEntry.roundedamount;
              } else {
                this.roundedamount = firstEntry.roundedamount;
              }
              this.ledger = firstEntry.ledger;
              this.fetchSectionData();
              this.onSearchClick();
            }
          } else {
            this.isLoadingVoucher = false;
          }
        } else {
          this.isLoadingVoucher = false;
        }
        if (voucherData.uploadedFiles?.length) {
          this.uploadedFiles = voucherData.uploadedFiles.map((file: any) => ({
            ...file,
            preview: `${this.fullhostname}/api/storage/${file.image}`,
          }));
          this.myFiles = [...this.uploadedFiles];
        } else {
          this.uploadedFiles = [];
          this.myFiles = [];
        }
      },
      (error) => {
        console.error("Error fetching voucher data:", error);
        this.isLoadingVoucher = false;
      },
    );
  }
  fetchbranchData() {
    this.apiService.getbranchData().subscribe(
      (response) => {
        this.branchdata = response;
        console.log("branchesss:", this.branchdata);
      },
      (error) => {
        console.error("Error fetching data:", error);
      },
    );
  }
  fetchSectionData() {
    this.apiService.getSection().subscribe(
      (response) => {
        this.sectionData = response;
        this.all_section_data = response;
        this.filteredSections = this.sectionData.filter((s) =>
          this.profit_cost_id.includes(s.profit_cost_id),
        );
        this.selectedSection = this.section_selected;
        this.fetchGsn();
        console.log("section_data :", this.sectionData);
      },
      (error) => {
        console.error("Error fetching data:", error);
      },
    );
  }
  fetchGsn() {
    this.gsn = [];
    console.log('this.selectedCustomerBranch', this.selectedCustomerBranch);
    const postData = {
      section_id: this.selectedSection,
      customer_id: this.customer,
      customer_branch_id: this.selectedCustomerBranch,
    };
    this.apiService.getGsnByCustomer(postData).subscribe(
      (response) => {
        this.gsn = response;
      },
      (error) => {
        console.error("Error fetching data:", error);
      },
    );
  }

  fetchEmployeeData() {
    this.apiService.getAllEmployeeMasterList().subscribe(
      (response) => {
        console.log("Employee List response:", response);
        this.employee_data = response?.data || [];
      },
      (error) => {
        console.error("Error fetching employee list:", error);
      },
    );
  }
  fetchVoucherData() {
    this.apiService.getDataVoucher().subscribe(
      (response) => {
        this.vouchers = response.filter(
          (voucher) => voucher.voucher_type === "Sales",
        );

        if (this.vouchers.length > 0) {
          this.voucherType = this.vouchers[0].id;
          this.voucher_type = this.vouchers[0].voucher_type;
        }
      },
      (error) => {
        console.error(error);
      },
    );
  }
  fetchtaxData() {
    this.apiService.getGst().subscribe(
      (response) => {
        this.tax = response;
      },
      (error) => {
        console.error("Error fetching data:", error);
      },
    );
  }

  getCustomerBranch(CustomerId: number) {
    this.apiService
      .getCustomerVendorBranch(this.branch, CustomerId, "customer")
      .subscribe(
        (response) => {
          this.customerBranchData = response.customer_branch;
          const customerDetails = response.customer_branch[0]?.customer;
          this.customer_name = customerDetails.customer_name;
          this.customer_email = customerDetails.email;
          this.customer_phone = customerDetails.phone;
          this.customer_address = customerDetails.address;
          this.customer_address1 = customerDetails.address1;
          this.customer_district = customerDetails.district;
          this.customer_pincode = customerDetails.pin_code;
          this.customer_city = customerDetails.city;
          this.customer_pan = customerDetails.pan;
          this.gstType();
        },
        (error) => {
          console.error("Error fetching customer branch:", error);
        },
      );
  }
  CustomerBranchdetails(CustomerId: number) {
    this.apiService.customerbranchdetails(CustomerId).subscribe(
      (response) => {
        this.customerBranchdetails = response;
        console.log("customer branch details", this.customerBranchdetails);
        this.customer_branch_gst = this.customerBranchdetails.gst_number ?? "";
        this.customer_branch_address = this.customerBranchdetails.address ?? "";
        this.customer_branch_address1 =
          this.customerBranchdetails.address1 ?? "";
        this.customer_branch_city = this.customerBranchdetails.city ?? "";
        this.customer_branch_pincode =
          this.customerBranchdetails.pin_code ?? "";
        this.customer_branch_district =
          this.customerBranchdetails.district ?? "";
        this.customer_branch_name =
          this.customerBranchdetails.branch_name ?? "";
        this.customer_branch_state =
          this.customerBranchdetails.state_name ?? "";
        this.customer_branch_tan_no = this.customerBranchdetails.tan_no ?? "";
        this.customer_branch_cin_no = this.customerBranchdetails.cin_no ?? "";
      },
      (error) => {
        console.error("Error fetching branch data:", error);
      },
    );
  }
  onSearchClick(): void {
    if (this.selectedGsn?.length) {
      console.log("gsn");
      this.fetchGsnProductList();
    }
  }
  getPassQtyForSku(product: any, skuId: number): number {
    let total = 0;
    if (product?.quality_check?.length) {
      for (const qc of product.quality_check) {
        if (qc.details?.length) {
          for (const d of qc.details) {
            if (d.sku_id === skuId) {
              total = Number(d.pass_qty) || 0;
            }
          }
        }
      }
    }
    return total;
  }
  fetchGsnProductList(): void {
    console.log("gsn2");
    this.apiService
      .getGsnDetails(
        this.selectedGsn,
        this.profit_cost_id,
        this.selectedSection,
      )
      .subscribe(
        (response) => {
          const missingNames: string[] = [];
          const gsnList: any[] = [];
          for (const gsn of response.data || []) {
            for (const detail of gsn.details || []) {
              detail.send_qty = Number(detail.send_qty) || 0;
              detail.unit_price = Number(detail.unit_price) || 0;
              detail.discount_amount = Number(detail.discount_amount) || 0;
              detail.incentive_amount = Number(detail.incentive_amount) || 0;

              if (detail.item_service_type === "SKU") {
                const skuMaps = detail.sku?.sku_detail_maps || [];
                const missingCrMaps = skuMaps.filter(
                  (m: any) =>
                    m.cr_ledger === null && m.voucher_id === this.voucherType,
                );
                if (missingCrMaps.length > 0) {
                  const skuName = detail.sku?.sku_name || "Unknown SKU";
                  missingNames.push(skuName);
                }
              }
              if (detail.item_service_type === "Service") {
                const serviceLedger = detail.service?.service_ledger_map;

                if (
                  serviceLedger &&
                  serviceLedger.cr_ledger === null &&
                  serviceLedger.voucher_id === this.voucherType
                ) {
                  const serviceName =
                    detail.service?.service_name || "Unknown Service";
                  missingNames.push(serviceName);
                }
              }
            }
            gsnList.push({
              ...gsn,
              details: (gsn.details || []).filter((detail: any) =>
                this.data?.id
                  ? this.productEntries &&
                    this.productEntries.some(
                      (entry: any) =>
                        (entry.productType?.id == detail.sku_id ||
                          entry.productType?.id == detail.service_id ||
                          entry.productType?.id == detail.fa_template_id) &&
                        entry.grn_gsn_details_id == detail.id &&
                        entry.profit_cost_id == detail.profit_cost_id &&
                        entry.selectedSection == detail.section_id,
                    )
                    ? true
                    : Number(detail.send_qty) != 0 && detail.remaining_qty != 0
                  : Number(detail.send_qty) != 0 && detail.remaining_qty != 0,
              ),
            });
          }
          if (missingNames.length > 0) {
            alert(`CR Ledger not found for: ${missingNames.join(", ")}`);
          }
          this.productList = gsnList;
          this.fetchtaxData();
          this.isLoadingVoucher = false;
        },
        (error) => {
          console.error("Error fetching Po products:", error);
          this.productList = [];
          this.isLoadingVoucher = false;
        },
      );
  }
  onProfitCost(profitCostId: number | number[]) {
    const pc_cc_ids = Array.isArray(profitCostId)
      ? profitCostId
      : [profitCostId];

    // Edit Sales Voucher
    if (this.data?.id && this.salesInvoice) {
      this.gstType();
      this.fetchSalesInvoiceDetails(this.salesInvoice);
      return;
    }

    // Create Sales Voucher
    this.profitCostId = pc_cc_ids;

    const selectedProfitCost = this.profit_cost.find((item: any) =>
      pc_cc_ids.includes(item.id),
    );

    if (selectedProfitCost) {
      this.store_id_for_items = selectedProfitCost.store_id;
    }

    this.filteredSections = this.all_section_data.filter((sec: any) =>
      pc_cc_ids.includes(sec.profit_cost_id),
    );
    this.resetLedgerState();
    this.fetchProfitCostLedger(pc_cc_ids);
    this.fetchStoreData();
    this.resetFields(["voucherType", "branch", "profit_cost_id"]);
  }
  fetchSalesInvoiceDetails(Invoice_Id: number, savedDetails: any[] = []) {
    const data = {
      Invoice_Id: Invoice_Id,
      profit_cost_id: this.profit_cost_id,
    };
    this.apiService.PostedVoucherdetails(data).subscribe(
      (response) => {
        console.log("sales invoice details", response);
        this.sales_invoice_details = response;
        this.customers = this.sales_invoice_details[0].customer_name;
        this.cutomer_branchs =
          this.sales_invoice_details[0].customer_branch_name;
        this.customer_branch_name = this.sales_invoice_details[0].customer_branch_name;
        this.customer_address = this.sales_invoice_details[0].customer_address;
        this.customer_email = this.sales_invoice_details[0].customer_email;
        this.customer_pan = this.sales_invoice_details[0].customer_pan;
        this.cutomer_branchs = this.sales_invoice_details[0].customer_branch_name;
        this.customer_branch_gst = this.sales_invoice_details[0].customer_branch_gst;
        this.customer_branch_address = this.sales_invoice_details[0].customer_branch_address;
        this.customer_branch_address1 = this.sales_invoice_details[0].customer_branch_address1;
        this.customer_branch_city = this.sales_invoice_details[0].customer_branch_city;
        this.customer_branch_district = this.sales_invoice_details[0].customer_branch_district;
        this.customer_branch_pincode = this.sales_invoice_details[0].customer_branch_pincode;
        this.customer_branch_state = this.sales_invoice_details[0].customer_branch_state;
        this.customer_branch_cin_no = this.sales_invoice_details[0].customer_branch_cin_no;
        this.customer_branch_tan_no = this.sales_invoice_details[0].customer_branch_tan_no;
        this.customer_phone = this.sales_invoice_details[0].customer_phone;
        this.unit_name = this.sales_invoice_details[0].unit_name;
        this.invoice_date = this.sales_invoice_details[0].sales_invoice_date;
        this.vendorBranchGstType = this.sales_invoice_details[0].customer_branch_gst_type;
        this.customerbranchledger(this.sales_invoice_details[0].customer_branch_id, this.branch);

        if (savedDetails && savedDetails.length > 0) {
          this.sales_invoice_details.forEach((item) => {
            const match = savedDetails.find(
              (d) =>
                d.grn_gsn_details_id === item.grn_gsn_details_id &&
                d.product_id === item.product_id,
            );
            if (match) {
              item.change_qty = match.qty;
              item.change_value = match.value;
              item.pending_qty = Number(item.pending_qty) + Number(match.qty);
              item.final_discount = match.discount_amount;
              item.final_incentive = match.incentive_amount;
            }
          });
          console.log(
            "sales invoice details final",
            this.sales_invoice_details,
          );
        }
      },
      (error) => {
        console.error("Error fetching voucher number:", error);
      },
    );
  }
  gstType() {
    if (this.selectedCustomerBranch && Array.isArray(this.customerBranchData)) {
      const customerBranch = this.customerBranchData.find(
        (branch: any) => branch.id === this.selectedCustomerBranch,
      );

      this.vendorBranchGstType = customerBranch?.gst_type ?? null;
      this.vendorBranchGstNumber = customerBranch?.gst_number ?? null;
    }
  }
  resetLedgerState() {
    this.rounded_ledger_data = [];
    this.hasMore = true;
    this.currentSearch = "";
  }
  resetFields(excludedFields: string[] = []) {
    const defaultValues: any = {
      branch: null,

      profit_cost_id: null,

      voucherType: null,

      customer: null,

      selectedCustomerBranch: null,

      selectedSection: [],

      selectedGsn: [],

      productList: [],
    };

    for (const key in defaultValues) {
      if (!excludedFields.includes(key)) {
        (this as any)[key] = defaultValues[key];
      }
    }
  }
  customerbranchledger(customer_branch_id, branch_id) {
    const postData = {
      customer_branch_id: customer_branch_id,
      branch_id: branch_id,
    };
    this.apiService.getCustomerBranchLedger(postData).subscribe(
      (response) => {
        this.customerBranchLedger = response;
        console.log("customer branch ledgerss", this.customerBranchLedger);
        this.cutomer_branch_ledger_id = this.customerBranchLedger[0].ledger_id;
        this.cutomer_branch_ledger_name =
          this.customerBranchLedger[0].ledger.ledger_name;
        console.log("customer branch ledger", this.cutomer_branch_ledger_id);
        console.log(
          "customer branch ledger name ",
          this.cutomer_branch_ledger_name,
        );
      },
      (error) => {
        console.error("Error fetching voucher number:", error);
      },
    );
  }
  fetchProfitCostLedger(
    profitCostId: number | number[],
    reset: boolean = false,
  ) {
    if (this.loading) return;
    if (!this.hasMore && !reset) return;

    if (reset) {
      this.hasMore = true;
      this.rounded_ledger_data = [];
    }
    const ids = Array.isArray(profitCostId) ? profitCostId : [profitCostId];
    this.loading = true;
    const offset = this.rounded_ledger_data.length;
    this.apiService
      .getProfitCostLedger(ids, true, {
        offset: offset,
        limit: this.limit,
        search: this.currentSearch,
        ledger_ids: this.ledger_ids,
      })
      .subscribe(
        (res: any) => {
          const data = res.ledger_data || [];
          this.rounded_ledger_data = [...this.rounded_ledger_data, ...data];
          if (data.length < this.limit) {
            this.hasMore = false;
          }
          this.loading = false;
        },
        () => (this.loading = false),
      );
  }
  fetchStoreData() {
    const postData = {
      profit_cost_id: this.profit_cost_id,
    };
    console.log("profit cost id", postData);
    this.apiService.getStoreByPcCc(postData).subscribe(
      (response) => {
        this.store_data = response;
        console.log("store data", this.store_data);
      },
      (error) => {
        console.error("Error fetching data:", error);
      },
    );
  }

  fetchProfitCostData(): void {
    const postData = {
      branch_id: this.branch,
    };
    this.apiService.getProfitCostByStore(postData).subscribe(
      (response) => {
        this.profit_cost = response;
      },
      (error) => {
        console.error("Error fetching data:", error);
      },
    );
  }
  getTitle(): string {
    return this.panelTitle;
  }
  getButton(): string {
    return this.panelMode === 'create' || this.operationType === 'create' ? 'Create' : 'Update';
  }
  closeDialog(): void {
    this.onClose();
  }

  get isInputDisabled(): boolean {
    return this.panelMode === 'view';
  }

  get voucherSubTotal(): number {
    return Number(this.getTotalAmount2() || 0);
  }

  get voucherTaxTotal(): number {
    return Number(this.getTotalGSTAmount2() || 0);
  }

  get voucherGrandTotal(): number {
    return Number(this.totalcredit2() || 0);
  }

  get isDebitCreditMatched(): boolean {
    if (!this.productList?.length) return false;
    const cr = Number(this.totalcredit2()).toFixed(2);
    const dr = Number(this.getTotalRoundedAmount2()).toFixed(2);
    return cr === dr;
  }

  get amountInWords(): string {
    return this.numberToWords(this.voucherGrandTotal);
  }

  private numberToWords(amount: number): string {
    if (amount == null || isNaN(amount)) return '';
    const ones = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen',
    ];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const convert = (n: number): string => {
      if (n < 20) return ones[n];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
      if (n < 1000) return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + convert(n % 100) : '');
      if (n < 100000) return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + convert(n % 1000) : '');
      if (n < 10000000) return convert(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + convert(n % 100000) : '');
      return convert(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + convert(n % 10000000) : '');
    };
    const rupees = Math.floor(Math.abs(amount));
    const paise = Math.round((Math.abs(amount) - rupees) * 100);
    let words = convert(rupees) || 'Zero';
    words += ' Rupees';
    if (paise > 0) {
      words += ' and ' + convert(paise) + ' Paise';
    }
    return words + ' Only';
  }

  private initPanelMode(): void {
    const op = (this.operationType || this.data?.type || '').toString().toLowerCase();
    if (op === 'view') {
      this.panelMode = 'view';
      this.isView = true;
      this.isUpdate = true;
    } else if (op === 'update') {
      this.panelMode = 'edit';
      this.isView = false;
      this.isUpdate = true;
    } else {
      this.panelMode = 'create';
      this.isView = false;
      this.isUpdate = false;
    }
  }

  get panelTitle(): string {
    switch (this.panelMode) {
      case 'create': return 'Create Sales Voucher';
      case 'edit': return this.voucherNo ? `Edit Sales Voucher - ${this.voucherNo}` : 'Edit Sales Voucher';
      case 'view': return this.voucherNo ? `View Sales Voucher - ${this.voucherNo}` : 'View Sales Voucher';
      default: return 'Sales Voucher';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) return 'Draft';
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') return 'default';
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];
    if (!this.data?.id) { steps[0].state = 'active'; return steps; }
    if (status == null || status === 'Open') steps[0].state = 'active';
    else if (status === 'Pending') { steps[0].state = 'completed'; steps[1].state = 'active'; }
    else if (status === 'Approved') { steps[0].state = 'completed'; steps[1].state = 'completed'; steps[2].state = 'completed'; }
    else if (status === 'Rejected') { steps[0].state = 'completed'; steps[1].state = 'rejected'; }
    return steps;
  }

  canEdit(): boolean {
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditMode(): void {
    if (!this.canEdit()) return;
    this.enteredEditFromView = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.isUpdate = true;
    this.operationType = 'update';
    this.type = 'update';
    this.editSnapshot = this.captureEditSnapshot();
  }

  enterViewMode(): void {
    this.panelMode = 'view';
    this.isView = true;
    this.isUpdate = true;
    this.enteredEditFromView = false;
    this.editSnapshot = null;
    this.operationType = 'view';
    this.type = 'view';
  }

  private captureEditSnapshot(): string {
    return JSON.stringify({
      branch: this.branch ?? null,
      customer: this.customer ?? null,
      selectedCustomerBranch: this.selectedCustomerBranch ?? null,
      profit_cost_id: this.profit_cost_id ?? [],
      selectedSection: this.selectedSection ?? [],
      selectedGsn: this.selectedGsn ?? [],
      document_no: this.document_no ?? null,
      issue_date: this.issue_date ?? null,
      date: this.date ?? null,
      purchesnarration: this.purchesnarration ?? null,
      roundedamount2: this.roundedamount2 ?? 0,
      ledger: this.ledger ?? null,
    });
  }

  hasUnsavedChanges(): boolean {
    if (this.panelMode !== 'edit' || !this.editSnapshot) return false;
    return this.captureEditSnapshot() !== this.editSnapshot;
  }

  private restoreFromSnapshot(): void {
    if (!this.editSnapshot) return;
    const snapshot = JSON.parse(this.editSnapshot);
    this.branch = snapshot.branch;
    this.customer = snapshot.customer;
    this.selectedCustomerBranch = snapshot.selectedCustomerBranch;
    this.profit_cost_id = snapshot.profit_cost_id;
    this.selectedSection = snapshot.selectedSection;
    this.selectedGsn = snapshot.selectedGsn;
    this.document_no = snapshot.document_no;
    this.issue_date = snapshot.issue_date;
    this.date = snapshot.date;
    this.purchesnarration = snapshot.purchesnarration;
    this.roundedamount2 = snapshot.roundedamount2;
    this.ledger = snapshot.ledger;
  }

  onClose(): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges('close');
      return;
    }
    this.dialogRef.close();
  }

  onCancel(): void {
    if (this.panelMode === 'edit' && this.enteredEditFromView && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges('view');
      return;
    }
    this.dialogRef.close();
  }

  private handleExitIntent(intent: 'close' | 'view'): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges(intent);
      return;
    }
    this.executeExitIntent(intent);
  }

  private executeExitIntent(intent: 'close' | 'view'): void {
    if (intent === 'view') {
      this.enterViewMode();
    } else {
      this.dialogRef.close();
    }
  }

  private promptUnsavedChanges(intent: 'close' | 'view'): void {
    const promptRef = this.dialog.open(UiUnsavedChangesDialogComponent, {
      width: '440px',
      disableClose: true,
      panelClass: 'ui-unsaved-changes-dialog',
    });
    promptRef.afterClosed().subscribe((result: UnsavedChangesResult | undefined) => {
      if (!result || result === 'cancel') return;
      if (result === 'discard') {
        this.restoreFromSnapshot();
        this.executeExitIntent(intent);
        return;
      }
      if (result === 'save') {
        this.detail();
      }
    });
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      const actions: UiPanelAction[] = [];
      if (this.canEdit()) {
        actions.push({ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true });
      }
      if (this.showPostButton && this.is_posted != 1 &&
          (this.approval_status === true || this.data?.approval_status === 'Approved')) {
        actions.push({ id: 'post', label: 'Post', icon: 'publish', variant: 'success', visible: true });
      }
      return actions;
    }
    return [
      {
        id: 'save',
        label: this.getButton(),
        icon: 'save',
        variant: 'success',
        visible: this.data?.approval_status !== 'Approved',
      },
      {
        id: 'send-approval',
        label: 'Send For Approval',
        icon: 'send',
        variant: 'primary',
        visible: !!this.data?.id && this.canEdit(),
      },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    return [
      {
        id: 'ledger-preview',
        label: 'View',
        icon: 'visibility',
        variant: 'outline',
        visible: this.panelMode !== 'view' && this.productList?.length > 0,
      },
      {
        id: 'pdf-original',
        label: 'Original Copy',
        icon: 'picture_as_pdf',
        variant: 'outline',
        visible: this.panelMode !== 'view' && this.isSales,
      },
      {
        id: 'pdf-duplicate',
        label: 'Duplicate Copy',
        icon: 'picture_as_pdf',
        variant: 'outline',
        visible: this.panelMode !== 'view' && this.isSales,
      },
      {
        id: 'pdf-extra',
        label: 'Extra Copy',
        icon: 'picture_as_pdf',
        variant: 'outline',
        visible: this.panelMode !== 'view' && this.isSales,
      },
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        variant: 'outline',
        visible: !!this.data?.id &&
          (this.data.approval_status === 'Pending' ||
            this.data.approval_status === 'Rejected' ||
            this.data.approval_status === 'Approved') &&
          this.panelMode !== 'view',
      },
      {
        id: 'cancel',
        label: this.panelMode === 'view' ? 'Close' : 'Cancel',
        icon: 'close',
        variant: 'outline',
        visible: true,
      },
    ];
  }

  get footerDestructiveAction(): UiPanelAction | null {
    const status = this.data?.approval_status;
    if (this.panelMode !== 'view' || !this.data?.id || status === 'Approved' || status === 'Pending') {
      return null;
    }
    return { id: 'delete', label: 'Delete', icon: 'delete', variant: 'danger', visible: true };
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) return [];
    const status = this.data.approval_status;
    return [
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        visible: status === 'Pending' || status === 'Rejected' || status === 'Approved',
      },
      { id: 'pdf-original', label: 'Original Copy', icon: 'picture_as_pdf', visible: true },
      { id: 'pdf-duplicate', label: 'Duplicate Copy', icon: 'picture_as_pdf', visible: true },
      { id: 'pdf-extra', label: 'Extra Copy', icon: 'picture_as_pdf', visible: true },
    ];
  }

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save':
        this.detail();
        break;
      case 'post':
        this.posting();
        break;
      case 'send-approval':
        this.sendForApprove();
        break;
      case 'ledger-preview':
        this.openproductView(0);
        break;
      case 'pdf-original':
        this.convertToPdf('original');
        break;
      case 'pdf-duplicate':
        this.convertToPdf('duplicate');
        break;
      case 'pdf-extra':
        this.convertToPdf('extra');
        break;
      case 'timeline':
        this.showApprovalTimeline();
        break;
      case 'edit':
        this.enterEditMode();
        break;
      case 'delete':
        this.deleteVoucherFromView();
        break;
      case 'cancel':
      case 'close':
        this.onCancel();
        break;
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode === 46) return true;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  onLedgerOpen(opened: boolean): void {
    if (!opened) return;
    this.hasMore = true;
    this.rounded_ledger_data = [];
    this.fetchProfitCostLedger(this.profitCostId || this.profit_cost_id, true);
    Promise.resolve().then(() => {
      const panel = this.ledgerSelect?.panel?.nativeElement;
      if (!panel) return;
      panel.removeEventListener('scroll', this.onLedgerScroll);
      panel.addEventListener('scroll', this.onLedgerScroll);
    });
  }

  filterLedger(event: any): void {
    this.currentSearch = event.target.value;
    this.hasMore = true;
    this.rounded_ledger_data = [];
    this.fetchProfitCostLedger(this.profitCostId || this.profit_cost_id, true);
  }

  onLedgerScroll = (event: any) => {
    const panel = event.target;
    if (
      panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 10 &&
      this.hasMore &&
      !this.loading
    ) {
      this.fetchProfitCostLedger(this.profitCostId || this.profit_cost_id);
    }
  };

  onFileSelected(event: any) {
    this.getFileDetails(event);
  }
  getFileDetails(e) {
    for (let i = 0; i < e.target.files?.length; i++) {
      const file = e.target.files[i];
      this.myFiles.push(file);
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedFiles.push({
          file: event.target.result,
          name: file.name,
          preview: event.target.result,
        });
        console.log("Reader result:", event.target.result);
      };
      reader.readAsDataURL(file);
    }
  }
  fetchvouchertype(id: number): any {
    this.voucher_data = this.vouchers.find((item) => item.id === id);
    this.voucher_type = this.voucher_data.voucher_type;
    if (this.voucher_type == "Sales") {
      this.fetchCombinedData();
    }
    this.fetchbranchData();
    console.log("voucher data", this.voucher_data);
    console.log("voucher type", this.voucher_type);
    this.resetFields(["voucherType"]);
  }
  fetchCombinedData() {
    this.adminService.getGlobalItem().subscribe(
      (skuResponse) => {
        this.apiService.getService().subscribe(
          (serviceResponse) => {
            this.combinedDropdownData = [
              {
                category: "SKU",
                items: skuResponse.data.map((item) => ({
                  ...item,
                  type: "SKU",
                })),
              },
              {
                category: "Service",
                items: serviceResponse.map((item) => ({
                  ...item,
                  type: "Service",
                })),
              },
            ];
            console.log(this.combinedDropdownData);
          },
          (error) => {
            console.error("Error fetching service data:", error);
          },
        );
      },
      (error) => {
        console.error("Error fetching SKU data:", error);
      },
    );
  }


  //manual
  onSelectionChange(selected: any) {
    console.log("selecteddddddddddddddd", selected);
    console.log("store_id", this.store_id_for_items);
    if (selected.type === "SKU") {
      this.apiService.getSku(this.store_id_for_items, selected.id).subscribe(
        (response) => {
          console.log("responseeeeeeeeee", response);
          this.selectedItem = response[0];
          this.selectedItem.type = "SKU";
          this.fetchhsnno(this.selectedItem);
        },
        (error) => {
          console.error("Error fetching data:", error);
        },
      );
    } else {
      this.selectedItem = selected;
      this.fetchhsnno(this.selectedItem);
    }
    // this.selectedItem = selected;
    this.fetchtaxData();
  }
  addProduct() {
    if (
      this.selectedItem &&
      this.unit &&
      this.selectedQty !== null &&
      this.selectedUnitPrice !== null &&
      this.selectedTaxType
    ) {
      this.productEntries.push({
        productType: this.selectedItem,
        hsn_no: this.hsn_no,
        description: this.selectedDescription || null,
        unit: this.unit,
        ledger_name: this.ledger_name,
        ledger_id: this.ledger_id,
        qty: this.selectedQty.toFixed(3),
        unitPrice: this.selectedUnitPrice,
        discount: this.selectedDiscount !== null ? this.selectedDiscount : 0,
        taxType: this.selectedTaxType,
      });
      // Reset form fields after adding the product
      this.selectedItem = null;
      this.hsn_no = null;
      this.selectedDescription = "";
      this.unit = null;
      this.ledger_name = "";
      this.ledger_id = null;
      this.selectedQty = null;
      this.selectedUnitPrice = null;
      this.selectedDiscount = null;
      this.selectedTaxType = null;
    } else {
      alert("Please fill out all required fields before adding the product.");
    }
  }
  openproductView(index: number): void {
    const productToEdit = this.productEntries[index];
    const selectedCustomerBranch = Array.isArray(this.customerBranchData)
      ? this.customerBranchData.find(
        (branch) => branch.id === this.selectedCustomerBranch,
      )
      : null;
    const selectedCustomerBranchName = selectedCustomerBranch ? selectedCustomerBranch.branch_name : "";
    let selectedCustomerBranchLedgerId: number | null = null;
    let selectedCustomerBranchLedgerName: string = "";

    if (
      selectedCustomerBranch &&
      Array.isArray(selectedCustomerBranch.customerbranch_map)
    ) {
      const matchedMapping = selectedCustomerBranch.customerbranch_map.find(
        (mapping) => mapping.company_branch_id === this.branch,
      );

      if (matchedMapping && matchedMapping.ledger) {
        selectedCustomerBranchLedgerId = matchedMapping.ledger_id;
        selectedCustomerBranchLedgerName = matchedMapping.ledger.ledger_name;
      }
    }

    const selectedVoucher = this.vouchers.find(
      (voucher) => voucher.id === this.voucherType,
    );
    const selectedVoucherType = selectedVoucher?.voucher_type || "";
    const gstLedgers = [];
    this.productList.forEach((product) => {
      product.details.forEach((detail) => {
        const gstLedger = this.tax.find(
          (item) => item.global_gst_id === detail.hsn_sac?.gst_id,
        );
        gstLedgers.push(gstLedger);
      });
    });
    let dialogData: any;
    const correctedEntries = this.productEntries.map((entry) => {
      return {
        ...entry,
        productType: this.getOriginalItem(entry.productType),
      };
    });
    if (
      this.selectedGrn?.some((grn) => grn !== null) ||
      this.selectedGsn?.some((gsn) => gsn !== null)
    ) {
      // purchase/sales
      dialogData = {
        branch_id: this.branch,
        grn: this.selectedGrn,
        gsn: this.selectedGsn,
        productOptions: this.productList,
        totalDiscount: this.getTotaldiscount2(),
        totalAmount: this.getTotalAmount2(),
        totalGSTAmount: this.getTotalGSTAmount2(),
        productList: this.productList,
        taxledger: gstLedgers,
        total_cr: this.totalcredit2(),
        total_dr: this.getTotalRoundedAmount2(),
        round_up: Math.abs(this.roundedamount2) || null,
        round_label: this.roundedamount2 < 0 ? "Down" : "Up",
        rounded_ledger: this.roundedledgername2(),
        voucher: selectedVoucherType,
        gstMatch: this.gstMatch(),
        gst_type: this.vendorBranchGstType,
        voucher_id: this.voucherType,
      };
    }
    if (selectedVoucherType === "Sales") {
      Object.assign(dialogData, {
        selectedCustomerBranch: selectedCustomerBranchName,
        selectedCustomerBranchLedgerId: selectedCustomerBranchLedgerId,
        selectedCustomerBranchLedgerName: selectedCustomerBranchLedgerName,
      });
    }
    this.dialog.open(CreateProductViewDialogComponent, {
      width: "1200px",
      height: "550px",
      data: dialogData,
    });
  }
  fetchhsnno(data: any) {
    this.apiService.gethsnno(data, this.voucher_type).subscribe(
      (response) => {
        this.hsn_no = response.hsn_no;
        this.ledger_name = response.ledger_name;
        this.ledger_id = response.ledger_id;
        this.unit = response.unit_name;
        this.selectedDescription = response.description;
      },
      (error) => {
        console.error("Error fetching voucher number:", error);
      },
    );
  }
  getProfitCostName(profitCostId: number): string {
    const pc = this.profit_cost.find((item: any) => item.id === profitCostId);
    return pc ? pc.name : '';
  }

  cgstAmount(detail: any): string | number {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
      const value = this.selectedGrn.length !== 0
        ? detail.receive_qty * detail.unit_price
        : (detail.send_qty * detail.unit_price) - detail.discount_amount + detail.incentive_amount;
      const gstLedger = this.tax.find((item: any) => item?.global_gst_id === detail.hsn_sac?.gst_id);
      if (!gstLedger) return 0;
      const cgstPercent = this.getCGSTPercentage(gstLedger?.global_gst_id) || 0;
      const cgstAmount = (value * cgstPercent) / 100;
      return cgstAmount.toFixed(2);
    }
    return 0;
  }

  sgstAmount(detail: any): string | number {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
      const value = this.selectedGrn.length !== 0
        ? detail.receive_qty * detail.unit_price
        : (detail.send_qty * detail.unit_price) - detail.discount_amount + detail.incentive_amount;
      const gstLedger = this.tax.find((item: any) => item.global_gst_id === detail.hsn_sac?.gst_id);
      if (!gstLedger) return 0;
      const sgstPercent = this.getSGSTPercentage(gstLedger?.global_gst_id) || 0;
      const sgstAmount = (value * sgstPercent) / 100;
      return sgstAmount.toFixed(2);
    }
    return 0;
  }

  igstAmount(detail: any): string | number {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && !this.gstMatch()) {
      let value = this.selectedGrn.length !== 0
        ? detail.receive_qty * detail.unit_price
        : (detail.send_qty * detail.unit_price) - detail.discount_amount + detail.incentive_amount;
      const gstLedger = this.tax.find((item: any) => item.global_gst_id === detail.hsn_sac?.gst_id);
      if (!gstLedger) return 0;
      const igstPercent = this.getIGSTPercentage(gstLedger?.global_gst_id) || 0;
      const igstAmount = (value * igstPercent) / 100;
      return igstAmount.toFixed(2);
    }
    return 0;
  }

  productTaxAmount2(detail: any) {
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType !== 'REGISTER') return 'NA';
    let value = 0;
    const gstLedger = this.tax.find((item: any) => item.global_gst_id === detail.hsn_sac?.gst_id);
    if (!gstLedger) return 0;
    value = this.selectedGrn.length !== 0 ? detail.receive_qty * detail.unit_price : (detail.send_qty * detail.unit_price) - detail.discount_amount + detail.incentive_amount;
    const discount = value * (0 / 100);
    const taxableValue = value - discount;
    const cgst = taxableValue * this.getCGSTPercentage(gstLedger?.global_gst_id) / 100;
    const sgst = taxableValue * this.getSGSTPercentage(gstLedger?.global_gst_id) / 100;
    return cgst + sgst;
  }

  lineItemCgstAmount(detail: any) {
    if (
      !this.vendorBranchGstType ||
      this.vendorBranchGstType === "UNREGISTERED"
    )
      return "NA";
    if (
      this.vendorBranchGstType === "SEZ" ||
      this.vendorBranchGstType === "COMPOSITE"
    )
      return 0;
    if (this.vendorBranchGstType === "REGISTER" && this.gstMatch()) {
      let value = 0;
      const gstLedger = this.tax.find(
        (item) => item.global_gst_id === (detail.taxType || detail.gst_id),
      );
      let qtyToUse = detail.qty || 0;

      value = qtyToUse * (detail.unitPrice || detail.unit_price || 0);

      const discountPercentage = detail.discount || 0;
      const discount = value * (discountPercentage / 100);
      const taxableValue = value - discount;

      const cgst =
        (taxableValue * this.getCGSTPercentage(gstLedger.global_gst_id)) / 100;
      return cgst;
    }
    return 0;
  }
  lineItemSgstAmount(detail: any) {
    if (
      !this.vendorBranchGstType ||
      this.vendorBranchGstType === "UNREGISTERED"
    )
      return "NA";
    if (
      this.vendorBranchGstType === "SEZ" ||
      this.vendorBranchGstType === "COMPOSITE"
    )
      return 0;
    if (this.vendorBranchGstType === "REGISTER" && this.gstMatch()) {
      let value = 0;
      const gstLedger = this.tax.find(
        (item) => item.global_gst_id === (detail.taxType || detail.gst_id),
      );
      let qtyToUse = detail.qty || 0;

      value = qtyToUse * (detail.unitPrice || detail.unit_price || 0);
      const discountPercentage = detail.discount || 0;
      const discount = value * (discountPercentage / 100);
      const taxableValue = value - discount;

      const sgst =
        (taxableValue * this.getSGSTPercentage(gstLedger.global_gst_id)) / 100;
      return sgst;
    }
    return 0;
  }
  lineItemIgstAmount(detail: any) {
    if (
      !this.vendorBranchGstType ||
      this.vendorBranchGstType === "UNREGISTERED"
    )
      return "NA";
    if (
      this.vendorBranchGstType === "SEZ" ||
      this.vendorBranchGstType === "COMPOSITE"
    )
      return 0;
    if (this.vendorBranchGstType === "REGISTER" && !this.gstMatch()) {
      let value = 0;
      let qtyToUse = detail.qty || 0;

      value = qtyToUse * (detail.unitPrice || detail.unit_price || 0);

      const gstLedger = this.tax.find(
        (item) => item.global_gst_id === (detail.taxType || detail.gst_id),
      );

      const discountPercentage = detail.discount || 0;
      const discount = value * (discountPercentage / 100);
      const taxableValue = value - discount;

      const igstPercent = this.getIGSTPercentage(gstLedger.global_gst_id) || 0;
      const igst = (taxableValue * igstPercent) / 100;
      return igst;
    }
    return 0;
  }

  getCGSTPercentage(taxTypeId: number): number {
    const gstPercentage = this.getTaxPercentage(taxTypeId);
    return gstPercentage / 2;
  }
  getSGSTPercentage(taxTypeId: number): number {
    const gstPercentage = this.getTaxPercentage(taxTypeId);
    return gstPercentage / 2;
  }
  getIGSTPercentage(taxTypeId: number): number {
    const gstPercentage = this.getTaxPercentage(taxTypeId);
    return gstPercentage;
  }
  gstMatch(): boolean {
    if (!Array.isArray(this.branchdata)) {
      return false;
    }
    const selectedBranch = this.branchdata.find(
      (branch: any) => branch.id === this.branch,
    );
    const branchGstFirst2 = selectedBranch?.gst?.substring(0, 2);
    let otherBranchGstFirst2: string | undefined;
    if (this.voucher_type === "Sales") {
      if (!Array.isArray(this.customerBranchData)) {
        return false;
      }
      const selectedCustomerBranch = this.customerBranchData.find(
        (customerBranch: any) =>
          customerBranch.id === this.selectedCustomerBranch,
      );
      otherBranchGstFirst2 = selectedCustomerBranch?.gst_number?.substring(
        0,
        2,
      );
    }

    if (!branchGstFirst2 || !otherBranchGstFirst2) {
      // console.warn('GST number missing for one of the branches.');
      return false;
    }
    return branchGstFirst2 === otherBranchGstFirst2;
  }
  getTaxPercentage(taxTypeId: number): number {
    const selectedTax = this.tax.find(
      (item) => item.global_gst_id === taxTypeId,
    );
    return selectedTax ? selectedTax.gst_percentage : 0;
  }
  getTotaldiscount(): number {
    return this.productEntries.reduce((totalDiscount, entry) => {
      const totalPrice = entry.qty * entry.unitPrice;
      const discountAmount = totalPrice * (entry.discount / 100);
      return totalDiscount + discountAmount;
    }, 0);
  }
  getTotalGSTAmount(): number {
    return this.productEntries.reduce((total, entry) => {
      const value = entry.qty * entry.unitPrice;
      const discount = value * (entry.discount / 100);
      const taxableValue = value - discount;
      const cgst = (taxableValue * this.getCGSTPercentage(entry.taxType)) / 100;
      const sgst = (taxableValue * this.getSGSTPercentage(entry.taxType)) / 100;
      return total + cgst + sgst;
    }, 0);
  }
  getOriginalItem(item: any) {
    for (const group of this.combinedDropdownData) {
      const match = group.items.find((x) => x.id === item.id);
      if (match) {
        return match;
      }
    }
    return item;
  }
  getTotalDiscountAmount(): number {
    return this.productList.reduce((total, product) => {
      return total + product.details.reduce((subTotal: number, detail: any) => subTotal + (Number(detail.discount_amount) || 0), 0);
    }, 0);
  }

  getTotalInceptiveAmount(): number {
    return this.productList.reduce((total, product) => {
      return total + product.details.reduce((subTotal: number, detail: any) => subTotal + (Number(detail.incentive_amount) || 0), 0);
    }, 0);
  }

  getTotaldiscount2(): number {
    return this.productList.reduce((totalDiscount, product) => {
      return (
        totalDiscount +
        product.details.reduce((detailDiscount, detail) => {
          const totalPrice =
            this.selectedGrn.length !== 0
              ? detail.receive_qty * detail.unit_price
              : detail.send_qty * detail.unit_price;
          const discountAmount = totalPrice * (0 / 100);
          return detailDiscount + discountAmount;
        }, 0)
      );
    }, 0);
  }
  getTotalAmount2(): number {
    return this.productList.reduce((total, product) => {
      const productTotal = product.details.reduce((detailTotal, detail) => {
        const value =
          this.selectedGrn.length !== 0
            ? detail.receive_qty * detail.unit_price
            : detail.send_qty * detail.unit_price;
        const discount = detail.discount_amount;
        const incentive = detail.incentive_amount;
        const taxableValue = value - discount + incentive;
        return detailTotal + taxableValue;
      }, 0);
      return total + productTotal;
    }, 0);
  }
  getTotalGSTAmount2(): number {
    if (this.vendorBranchGstType !== "REGISTER") return 0;
    if (this.vendorBranchGstType === "REGISTER") {
      return this.productList.reduce((total, product) => {
        const productGST = product.details.reduce((detailGST, detail) => {
          const value =
            this.selectedGrn.length !== 0
              ? detail.receive_qty * detail.unit_price
              : detail.send_qty * detail.unit_price -
              detail.discount_amount +
              detail.incentive_amount;
          const gstLedger = this.tax.find(
            (item) => item.global_gst_id === detail.hsn_sac.gst_id,
          );
          //if (!gstLedger) return 0;
          const discount = value * (0 / 100);
          const taxableValue = value - discount;
          const cgst =
            (taxableValue * this.getCGSTPercentage(gstLedger?.global_gst_id)) /
            100;
          const sgst =
            (taxableValue * this.getSGSTPercentage(gstLedger?.global_gst_id)) /
            100;
          return detailGST + cgst + sgst;
        }, 0);
        return total + productGST;
      }, 0);
    }
  }
  totalcredit2() {
    const roundedAmount2 = this.roundedamount2 ? this.roundedamount2 : 0;
    const totalcr = this.getTotalAmount2() + this.getTotalGSTAmount2();
    const finalAmount = totalcr + roundedAmount2;
    return finalAmount;
  }
  getTotalRoundedAmount2(): number {
    const roundedAmount2 = this.roundedamount2 ? this.roundedamount2 : 0;
    const totalAmount = this.getTotalAmount2() + this.getTotalGSTAmount2();
    const finalAmount = totalAmount + roundedAmount2;
    return finalAmount;
  }
  roundedledgername2() {
    const selectedledger = this.rounded_ledger_data.find(
      (ledger) => ledger.ledger_id == this.ledger,
    );
    const selectedLedgerName = selectedledger ? selectedledger.ledger_name : "";
    return selectedLedgerName;
  }
  customerBranchLedgerId() {
    let selectedCustomerBranchLedgerId: number | null = null;
    const selectedCustomerBranch = this.customerBranchData.find(
      (branch) => branch.id === this.selectedCustomerBranch,
    );
    if (
      selectedCustomerBranch &&
      Array.isArray(selectedCustomerBranch.customerbranch_map)
    ) {
      const matchedMapping = selectedCustomerBranch.customerbranch_map.find(
        (mapping) => mapping.company_branch_id === this.branch,
      );
      if (matchedMapping && matchedMapping.ledger) {
        selectedCustomerBranchLedgerId = matchedMapping.ledger_id;
      }
    }
    return selectedCustomerBranchLedgerId;
  }
  onSectionChange(sectionId: number) {
    if (sectionId) {
      this.resetFields([
        "voucherType",
        "branch",
        "profit_cost_id",
        "customer",
        "selectedCustomerBranch", 
        "selectedSection",
      ]);
      this.fetchGsn();
    }
  }

  onCustomerChange(CustomerId: number) {
    if (CustomerId) {
      this.getCustomerBranch(CustomerId);
      this.fetchSectionData();
      this.resetFields([
        "voucherType",
        "branch",
        "profit_cost_id",
        "customer",
        "selectedSection",
      ]);
    }
  }

  onCustomerBranchChange(customerbranchId: any) {
    if (customerbranchId) {
      this.CustomerBranchdetails(customerbranchId);
      this.fetchGsn();
    }
    this.resetFields([
      "voucherType",
      "branch",
      "profit_cost_id",
      "customer",
      "selectedCustomerBranch",
      "selectedSection",
    ]);
  }

  detail(isApproval: boolean = false): void {
    const hasGrnOrGsn = this.selectedGrn?.some(grn => grn !== null) || this.selectedGsn?.some(gsn => gsn !== null);
    if (!this.voucherType) {
      alert('Please select a voucher');
      return;
    }
    if (!this.date) {
      alert('Please select a date');
      return;
    }
    if (!this.customer) {
      alert('Please select a Customer');
      return;
    }
    if (!this.document_no) {
      alert('Please Select an External Document Number');
      return;
    }
    if (!this.issue_date) {
      alert('Please select a Document Date');
      return;
    }
    if (!this.purchesnarration) {
      alert('Please Enter Narration');
      return;
    }
    const totalDebit = this.getTotalRoundedAmount().toFixed(2);
    const totalCredit = this.totalcredit().toFixed(2);
    const totalDebit2 = this.getTotalRoundedAmount2().toFixed(2);
    const totalCredit2 = this.totalcredit2().toFixed(2);

    if (hasGrnOrGsn && totalDebit2 !== totalCredit2) {
      alert('Total debit does not match total credit!');
      return;
    }

    if (!hasGrnOrGsn && totalDebit !== totalCredit) {
      alert('Total debit does not match total credit!');
      return;
    }
    if (this.roundedamount2 && !this.ledger) {
      alert('Please select a Rounded Ledger.');
      return;
    }
    this.Save(isApproval);
  }

  Save(isApproval: boolean = false): void {
    const gstLedgers: { ledger_id: number; gstAmount: number }[] = this.getGroupedGstLedgers() as { ledger_id: number; gstAmount: number }[];
    this.debitEntries = [];
    this.creditEntries = [];
    this.details = [];
    const hasGrnOrGsn = this.selectedGrn?.some(grn => grn !== null) || this.selectedGsn?.some(gsn => gsn !== null);
    const amount = Math.abs(this.roundedamount2 || 0);

    const debitMap = new Map<number, number>();
    const prodDebitMap = new Map<number, number>();
    const groupedLedgers = this.getGroupedLedgers();
    groupedLedgers.forEach(entry => {
      if (entry.ledger_id !== null) {
        prodDebitMap.set(entry.ledger_id, entry.totalDiscountedAmount);
      }
    });
    const groupedGstDetails = this.getGroupedGstDetails();
    groupedGstDetails.forEach(entry => {
      debitMap.set(entry.ledger_id, entry.totalAmount);
    });

    const prodDebitMap2 = new Map<number, number>();
    this.productList.forEach(entry => {
      const salesOrders = Array.isArray(entry.sales_order)
        ? entry.sales_order
        : entry.sales_order ? [entry.sales_order] : [];

      entry.details.forEach((detail) => {
        const price = parseFloat(detail.unit_price) || 0;
        const qty = parseFloat(detail.send_qty) || 0;

        const discount = detail.discount_amount || 0;
        const incentive = detail.incentive_amount || 0;

        const totalAmount = price * qty;
        const taxableAmount = totalAmount - discount + incentive;

        const sku_maps = detail?.sku?.sku_detail_maps || [];
        const service_maps = detail?.service?.service_ledgr_map || [];
        const maps = detail.item_service_type === 'SKU' ? sku_maps : service_maps;
        const sectionIds = detail?.section_id
          ? detail.section_id.toString().split(',').map(Number)
          : [];

        sectionIds.forEach((sectionId: number) => {
          const match = maps.find((m: any) =>
            m.voucher_type === 'Sales' &&
            Number(m.section_id) === sectionId &&
            salesOrders.some((o: any) => {
              const oSections = o.section_id?.toString().split(',').map(Number);
              return oSections.includes(sectionId);
            })
          );
          if (!match) return;

          const ledgerId = match.cr_ledger;

          if (!ledgerId) return;
          const existing = prodDebitMap2.get(ledgerId) || 0;
          prodDebitMap2.set(ledgerId, existing + taxableAmount);
        });
      });
    });

    const hasNullProdLedger = Array.from(prodDebitMap2.keys()).some(
      key => key === null || key === undefined
    );

    const hasNullGstLedger = gstLedgers.some(
      item => item.ledger_id === null || item.ledger_id === undefined
    );

    if (hasNullProdLedger || hasNullGstLedger) {
      alert('Ledger mapping missing! Some product or GST ledger_id not found.');
      return;
    }

    if (hasGrnOrGsn) {
      if (this.vendorBranchGstType === 'REGISTER') {
        gstLedgers.forEach(ledger => {
          this.debitEntries.push({
            ledger_id: ledger.ledger_id,
            amount: ledger.gstAmount.toFixed(2),
            description: '',
          });
        });
      }
      prodDebitMap2.forEach((amount, prod_ledger_id) => {
        this.debitEntries.push({
          ledger_id: prod_ledger_id,
          amount: amount.toFixed(2),
          description: '',
        });
      });
    } else {
      debitMap.forEach((amount: number, ledger_id: number) => {
        this.debitEntries.push({
          ledger_id: ledger_id,
          amount: amount.toFixed(2),
          description: '',
        });
      });
      prodDebitMap.forEach((amount, prod_ledger_id) => {
        this.debitEntries.push({
          ledger_id: prod_ledger_id,
          amount: amount.toFixed(2),
          description: '',
        });
      });
    }

    if (this.ledger && this.roundedamount2 > 0) {
      this.debitEntries.push({
        ledger_id: this.ledger,
        amount,
        description: '',
      });
    } else if (this.ledger && this.roundedamount2 < 0) {
      this.creditEntries.push({
        ledger_id: this.ledger,
        amount,
        description: '',
      });
    } else if (this.ledger && this.roundedamount > 0) {
      this.debitEntries.push({
        ledger_id: this.ledger,
        amount: this.roundedamount || 0,
        description: '',
      });
    } else if (this.ledger && this.roundedamount < 0) {
      this.creditEntries.push({
        ledger_id: this.ledger,
        amount,
        description: '',
      });
    }

    const totalAmountVal = this.getTotalRoundedAmount().toFixed(2);
    const totalAmountVal2 = this.getTotalRoundedAmount2().toFixed(2);
    if (hasGrnOrGsn) {
      this.creditEntries.push({
        ledger_id: this.customerBranchLedgerId(),
        amount: totalAmountVal2,
        description: '',
      });
    } else {
      this.creditEntries.push({
        ledger_id: this.customerBranchLedgerId(),
        amount: totalAmountVal,
        description: '',
      });
    }

    const selectedCustomerBranch = Array.isArray(this.customerBranchData)
      ? this.customerBranchData.find(branch => branch.id === this.selectedCustomerBranch)
      : null;

    if (hasGrnOrGsn) {
      this.productList.forEach(entry => {
        const salesOrders = entry.sales_order ? [entry.sales_order] : [];
        const details = (entry.details || []).map(detail => {
          const item_service_type = detail?.item_service_type;
          const sku_maps = detail?.sku?.sku_detail_maps || [];
          const service_maps = detail?.service?.service_ledgr_map || [];
          const findLedger = (maps: any[], type: 'Purchase' | 'Sales', sectionIds: any[], ledgerKey: 'dr_ledger' | 'cr_ledger', nameKey: 'dr_ledger_name' | 'cr_ledger_name') => {
            const match = maps.find(m =>
              (m.voucher_type === type) &&
              (detail.section_id == (m.section_id))
            );
            return {
              id: match?.[ledgerKey],
              name: match?.[nameKey]
            };
          };

          const sectionIds = salesOrders.map(so => so.section_id);
          let ledgerInfo: any = { id: undefined, name: undefined };

          if (item_service_type === 'SKU') {
            ledgerInfo = findLedger(
              sku_maps,
              'Sales',
              sectionIds,
              'cr_ledger',
              'cr_ledger_name'
            );
          } else if (item_service_type === 'Service') {
            ledgerInfo = findLedger(
              service_maps,
              'Sales',
              sectionIds,
              'cr_ledger',
              'cr_ledger_name'
            );
          }
          return {
            product_id: item_service_type === 'SKU' ? detail?.sku?.id : item_service_type === 'Service' ? detail?.service?.id : detail?.fa_template?.id,
            name: item_service_type === 'SKU' ? detail?.sku?.item?.item_name : item_service_type === 'Service' ? detail?.service?.service_name : detail?.fa_template?.name,
            product_ledger: ledgerInfo.id ?? ledgerInfo.ledger_id,
            product_ledger_name: ledgerInfo.name ?? ledgerInfo.ledger_name,
            hsn_no: detail?.hsn_no,
            description: detail?.description,
            unit_name: detail?.unit?.unit_name,
            qty: detail?.send_qty,
            unit_price: detail?.unit_price,
            value: (detail?.send_qty || 0) * (detail?.unit_price || 0),
            discount_amount: detail?.discount_amount || 0,
            incentive_amount: detail?.incentive_amount || 0,
            gst_id: this.vendorBranchGstType === 'REGISTER' ? detail?.hsn_sac?.gst_id : '',
            rounded_amount: this.roundedamount2 || null,
            rounded_ledger: this.ledger || null,
            gst_ledger: this.vendorBranchGstType === 'REGISTER' ? gstLedgers : '',
            vendor_id: this.customer,
            branch_id: selectedCustomerBranch?.id || '',
            type: 'sales',
            grn_id: detail?.grn_id,
            gsn_id: detail?.gsn_id,
            section_id: detail?.section_id,
            item_type: detail?.item_service_type,
            profit_cost_id: (detail?.gsn_id) ? (detail?.profit_cost_id) : this.profit_cost_id ?? null,
            details_id: detail?.id,
            product_service_type: item_service_type,
            store_id: item_service_type === 'SKU' ? detail?.sku?.store_id : null,
            specification: detail?.specification,
          };
        });
        this.details.push(...details);
      });
    } else {
      const correctedEntries = this.productEntries.map(entry => {
        return {
          ...entry,
          productType: this.getOriginalItem(entry.productType)
        };
      });
      correctedEntries.forEach(entry => {
        const type = entry.productType.type;
        let product_ledger_id: any;
        let product_ledger_name: any;
        const sectionIds = Array.isArray(this.selectedSection) ? this.selectedSection : (this.selectedSection ? [this.selectedSection] : []);

        if (type === "Service") {
          const maps = entry.productType?.service_ledgr_map || [];
          const match = maps.find(m =>
            (m.voucher_type === 'Sales') &&
            (sectionIds.length === 0 || sectionIds.some(sid => Number(sid) === Number(m.section_id)))
          ) || maps[0];

          product_ledger_id = match?.cr_ledger ?? match?.ledger?.id;
          product_ledger_name = match?.cr_ledger_name ?? match?.ledger?.ledger_name;
        } else if (type === "SKU") {
          const skuMaps = entry.productType?.sku_detail_maps || [];
          const match = skuMaps.find(m =>
            (m.voucher_type === 'Sales') &&
            (sectionIds.length === 0 || sectionIds.some(sid => Number(sid) === Number(m.section_id)))
          );
          product_ledger_id = match?.cr_ledger;
          product_ledger_name = match?.cr_ledger_name;
        }
        this.details.push({
          product_id: entry.productType.id,
          name: type === "Service" ? entry.productType.service_name : entry.productType.sku_name,
          product_ledger: product_ledger_id,
          product_ledger_name: product_ledger_name,
          hsn_no: entry.hsn_no,
          description: entry.description,
          unit_name: entry.unit,
          qty: entry.qty,
          unit_price: entry.unitPrice,
          value: entry.qty * entry.unitPrice,
          discount: entry.discount,
          gst_id: entry.taxType,
          rounded_amount: this.roundedamount || null,
          rounded_ledger: this.ledger || null,
          vendor_id: this.customer,
          branch_id: selectedCustomerBranch?.id || '',
          type: 'sales',
          item_type: type,
          gst_ledger: groupedGstDetails.map(gst => ({
            ledger_id: gst.ledger_id,
            gst_id: entry.taxType,
          })),
          section_id: this.selectedSection,
          details_id: null,
          product_service_type: type,
          profit_cost_id: this.profit_cost_id,
        });
      });
    }

    const postDataSales = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      date: this.date,
      issue_date: this.issue_date,
      document_no: this.document_no,
      narration: this.purchesnarration,
      doc_type: 'sales',
      total_cr: hasGrnOrGsn ? this.totalcredit2().toFixed(2) : this.totalcredit().toFixed(2),
      total_dr: hasGrnOrGsn ? this.getTotalRoundedAmount2().toFixed(2) : this.getTotalRoundedAmount().toFixed(2),
      cr: this.debitEntries,
      dr: this.creditEntries,
      details: this.details,
      branch_id: this.branch ?? null,
      existing_uploads: this.existingFiles,
      new_uploads: this.uploadedFiles,
      profit_cost_id: this.profit_cost_id,
      section_id: this.selectedSection,
      type: this.operationType
    };

    console.log('sales postdata', postDataSales);
    if (this.data?.id) {
      this.apiService.updateVoucherPosting(this.data.id, postDataSales).subscribe(
        response => {
          if (response && (response.status === false || response.status === 'fail' || response.status === 'error')) {
            alert(response.message || 'Error updating voucher');
            return;
          }
          alert(response.message || 'Voucher updated successfully');
          console.log('Voucher updated successfully:', response);
          if (isApproval) {
            this.sendForApprove(true);
          } else {
            this.dialogRef.close(response);
          }
        },
        error => {
          console.error('Error updating voucher:', error);
          alert('Error updating voucher: ' + (error.error?.message || error.message || 'Unknown error'));
        }
      );
    } else {
      this.apiService.createVoucherPosting(postDataSales).subscribe(
        response => {
          if (response && (response.status === false || response.status === 'fail' || response.status === 'error')) {
            alert(response.message || 'Error creating voucher');
            return;
          }
          alert(response.message || 'Voucher Created successfully');
          console.log('Voucher Created successfully:', response);
          this.dialogRef.close(response);
        },
        error => {
          console.error('Error posting voucher:', error);
          alert('Error posting voucher: ' + (error.error?.message || error.message || 'Unknown error'));
        }
      );
    }
  }

  posting(): void {
    const payload = {
      selected_voucher: [this.data.id]
    };
    this.apiService.postVoucher(payload).subscribe(
      response => {
        alert('Voucher posted successfully');
        this.dialogRef.close(true);
      },
      error => {
        console.error('Error posting voucher:', error);
        alert('Error posting voucher');
      }
    );
  }

  sendForApprove(skipSave: boolean = false) {
    if (!skipSave && this.data.id) {
      this.detail(true);
      return;
    }

    console.log(this.data);
    const requestData = {
      document_type: 'Salesvoucher',
      document_id: this.data.id,
    };

    this.apiService.sendForApproval(requestData).subscribe(
      (approvalResponse) => {
        console.log('Voucher posting sent for approval:', approvalResponse);
        alert('Document sent for approval');
        this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
      },
      (approvalError) => {
        console.error('Error sending voucher posting for approval:', approvalError);
        alert('Error sending voucher posting for approval: ' + (approvalError.error?.message || approvalError.message || 'Unknown error'));
      }
    );
  }

  showApprovalTimeline() {
    const requestData = {
      document_type: 'Salesvoucher',
      document_id: this.data.id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
      }
    );
  }

  getGroupedGstLedgers() {
    const groupedLedgers: { [ledgerId: number]: any } = {};
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    if (!selectedVoucher) {
      console.warn("No matching voucher found.");
      return [];
    }
    for (const product of this.productList) {
      for (const detail of product.details) {
        const gstAmount = this.productTaxAmount2(detail);
        if (typeof gstAmount !== 'number' || isNaN(gstAmount)) continue;
        const gstId = detail.hsn_sac?.gst_id || 0;
        if (!gstId) continue;

        const tax = this.tax.find(t => t.global_gst_id === gstId);
        if (!tax) continue;

        for (const gstLedger of tax.gst_ledgers) {
          const requiredLedgerType = "payable";
          if (this.gstMatch()) {
            if (gstLedger.gst_type !== "CGST" && gstLedger.gst_type !== "SGST") continue;
          } else {
            if (gstLedger.gst_type !== "IGST") continue;
          }
          if (
            gstLedger.ledger_type === requiredLedgerType &&
            gstLedger.branch_id === this.branch
          ) {
            const ledgerId = gstLedger.ledger.id;
            const amountToAdd = this.gstMatch() ? gstAmount / 2 : gstAmount;
            if (groupedLedgers[ledgerId]) {
              groupedLedgers[ledgerId].gstAmount += amountToAdd;
            } else {
              groupedLedgers[ledgerId] = {
                gst_id: gstId,
                ledgerName: gstLedger.ledger.ledger_name,
                ledger_id: ledgerId,
                gstAmount: amountToAdd
              };
            }
          }
        }
      }
    }
    return Object.values(groupedLedgers);
  }

  getGroupedLedgers(): { ledger_id: number | null, ledger_name: string, totalDiscountedAmount: number }[] {
    const ledgerMap = new Map<number | string, { ledger_id: number | null, ledger_name: string, totalDiscountedAmount: number }>();
    const correctedEntries = this.productEntries.map(entry => {
      return {
        ...entry,
        productType: this.getOriginalItem(entry.productType)
      };
    });
    for (const entry of correctedEntries) {
      const type = entry.productType?.type;
      let ledgerId: number | null = null;
      let ledgerName = 'No ledger found';
      let match: any;
      if (type === 'SKU') {
        match = entry.productType?.sku_detail_maps?.find((map: any) => map.voucher_type === 'Sales');
        ledgerName = match?.cr_ledger_name ?? 'No Sales Sku ledger found';
        ledgerId = match?.cr_ledger ?? null;
      } else if (type === 'Service') {
        match = entry.productType?.service_ledgr_map?.[0];
        ledgerName = match?.ledger?.ledger_name ?? 'No Sales Service Ledger found';
        ledgerId = match?.ledger?.id ?? null;
      }
      const qty = entry.qty ?? 0;
      const unitPrice = entry.unitPrice ?? 0;
      const discount = entry.discount_amount ?? 0;
      const incentive = entry.incentive_amount ?? 0;
      const baseAmount = qty * unitPrice;
      const discountedAmount = baseAmount - discount + incentive;
      const key = ledgerId ?? 'null';
      if (ledgerMap.has(key)) {
        ledgerMap.get(key)!.totalDiscountedAmount += discountedAmount;
      } else {
        ledgerMap.set(key, {
          ledger_id: ledgerId,
          ledger_name: ledgerName,
          totalDiscountedAmount: discountedAmount
        });
      }
    }
    return Array.from(ledgerMap.values());
  }

  getGroupedGstDetails() {
    const groupedLedgers: { [key: number]: { ledger_id: number; totalAmount: number } } = {};
    this.productEntries.forEach((product: any) => {
      const gstDetailsArray = this.getGstLedgerDetails(product.taxType);
      gstDetailsArray.forEach(gstDetails => {
        const totalPrice = product.qty * product.unitPrice;
        const discountAmount = product?.discount_amount || 0;
        const incentiveAmount = product?.incentive_amount || 0;
        const discountedPrice = totalPrice - discountAmount + incentiveAmount;
        const gstAmount = (discountedPrice * gstDetails.gst_percentage) / 100;
        if (groupedLedgers[gstDetails.ledger_id]) {
          groupedLedgers[gstDetails.ledger_id].totalAmount += gstAmount;
        } else {
          groupedLedgers[gstDetails.ledger_id] = {
            ledger_id: gstDetails.ledger_id,
            totalAmount: gstAmount,
          };
        }
      });
    });
    return Object.values(groupedLedgers);
  }

  getGstLedgerDetails(taxType: number): { ledger_id: number; gst_percentage: number }[] {
    const gstLedger = this.tax.find(item => item.global_gst_id === taxType);
    if (!gstLedger) return [];
    const requiredLedgerType = 'payable';
    const isSameState = this.gstMatch();
    let gstLedgers = gstLedger.gst_ledgers.filter(
      ledger => ledger.ledger_type === requiredLedgerType && (!ledger.branch_id || ledger.branch_id == this.branch)
    );
    if (isSameState) {
      return gstLedgers
        .filter(l => l.gst_type === 'CGST' || l.gst_type === 'SGST')
        .map(l => ({
          ledger_id: l.ledger.id,
          gst_percentage: gstLedger.gst_percentage / 2
        }));
    } else {
      return gstLedgers
        .filter(l => l.gst_type === 'IGST')
        .map(l => ({
          ledger_id: l.ledger.id,
          gst_percentage: gstLedger.gst_percentage
        }));
    }
  }

  getTotalAmount(): number {
    return this.productEntries.reduce((total, entry) => {
      const value = entry.qty * entry.unitPrice;
      const discount = entry.discount_amount || 0;
      const incentive = entry.incentive_amount || 0;
      const taxableValue = (value - discount) + incentive;
      return total + taxableValue;
    }, 0);
  }
  getTotalRoundedAmount(): number {
    const totalAmount = this.getTotalAmount() + this.getTotalGSTAmount();
    return Math.ceil(totalAmount);
  }

  totalcredit() {
    const roundedAmount = this.roundedamount ? this.roundedamount : 0;
    const totalcr = this.getTotalAmount() + this.getTotalGSTAmount() + roundedAmount;
    return totalcr;
  }

  convertToPdf(copyKey: 'original' | 'duplicate' | 'extra' = 'original') {
    try {
      const selectedVoucher = this.vouchers?.find((voucher: any) => voucher.id === this.voucherType);
      const selectedBranch = this.branchdata?.find((branch: any) => branch.id == this.branch);
      const selectedCustomerBranch = Array.isArray(this.customerBranchData)
        ? this.customerBranchData.find((b: any) => b.id == this.selectedCustomerBranch)
        : null;

      if (!selectedCustomerBranch && !this.selectedCustomerBranch) {
        alert('Please select a Customer Branch.');
        return;
      }

      let resultArray: any[] = [];
      let totalbefortax = 0;
      let totaldiscount = 0;
      let totalafterdiscount = 0;
      let totaltax = 0;
      let roundedamount = 0;
      let totalamount = 0;

      if (this.selectedGsn && this.selectedGsn.length > 0 && this.productList && this.productList.length > 0) {
        let totalSum = 0;
        (this.productList || []).forEach((item: any) => {
          (item.details || []).forEach((detail: any) => {
            let itemName = detail?.item_service_type === 'SKU'
              ? detail?.sku?.sku_name
              : detail?.item_service_type === 'Service'
                ? detail?.service?.service_name
                : detail?.item_service_type === 'Fixed Asset'
                  ? detail?.fa_template?.name
                  : '';

            let cgst = 0, sgst = 0, igst = 0;
            const hsnData = detail?.hsn_sac;
            if (hsnData) {
              if (this.gstMatch()) {
                cgst = this.getCGSTPercentage(hsnData.gst_id) || 0;
                sgst = this.getSGSTPercentage(hsnData.gst_id) || 0;
              } else {
                igst = this.getIGSTPercentage(hsnData.gst_id) || 0;
              }
            }

            let qty = detail?.send_qty || detail?.qty || 0;
            let unitPrice = detail?.unit_price || 0;
            let totalItemAmount = qty * unitPrice;
            totalSum += totalItemAmount;

            let taxValue = this.productTaxAmount2(detail);
            let productgstAmount = typeof taxValue === 'number' ? taxValue.toFixed(2) : 'NA';

            resultArray.push({
              id: item.productType ?? '',
              name: itemName ?? '',
              product_service_no: detail?.product_service_no ?? '',
              description: detail?.description || detail?.sku?.description || detail?.service?.description || '',
              quantity: Number(qty).toFixed(3),
              unitprice: unitPrice,
              hsn: detail?.hsn_no ?? '',
              unit: detail?.unit?.unit_name ?? '',
              line_document_no: detail?.line_document_no ?? '',
              cgst,
              sgst,
              igst,
              amount: totalItemAmount,
              productgstAmount,
              category_name: detail?.hsn_sac?.description ?? '',
              gst_type: this.vendorBranchGstType,
              incentiveAmount: detail?.incentive_amount ?? 0,
              discountAmount: detail?.discount_amount ?? 0,
            });
          });
        });

        totalbefortax = totalSum;
        totaldiscount = this.getTotaldiscount2() || 0;
        totalafterdiscount = this.getTotalAmount2() || 0;
        totaltax = this.getTotalGSTAmount2() || 0;
        roundedamount = this.roundedamount2 || 0;
        totalamount = this.getTotalAmount2() + this.getTotalGSTAmount2() + (this.roundedamount2 || 0);
      } else {
        let totalSum = 0;
        (this.productEntries || []).forEach((item: any) => {
          let pType = item.productType;
          let itemName = pType?.sku_name || pType?.service_name || pType?.name || (typeof pType === 'string' ? pType : '');
          let cgst = 0, sgst = 0, igst = 0;
          const gstId = item.taxType;

          if (gstId) {
            if (this.gstMatch()) {
              cgst = this.getCGSTPercentage(gstId) || 0;
              sgst = this.getSGSTPercentage(gstId) || 0;
            } else {
              igst = this.getIGSTPercentage(gstId) || 0;
            }
          }

          let itemAmount = (item.qty || 0) * (item.unitPrice || 0);
          totalSum += itemAmount;
          let discountAmount = item.discount_amount || ((itemAmount * (item.discount || 0)) / 100);
          let productgstAmount = (Number(this.lineItemCgstAmount(item) || 0) + Number(this.lineItemSgstAmount(item) || 0) + Number(this.lineItemIgstAmount(item) || 0));

          resultArray.push({
            id: pType?.id || pType || '',
            name: itemName,
            description: item.description ?? '',
            quantity: item.qty ?? 0,
            unitprice: item.unitPrice ?? 0,
            hsn: item.hsn_no ?? '',
            unit: typeof item?.unit === 'object' ? item?.unit?.unit_name : (item?.unit || ''),
            cgst,
            sgst,
            igst,
            gst_type: this.vendorBranchGstType,
            amount: itemAmount,
            discountamount: discountAmount ? Number(discountAmount).toFixed(2) : '0.00',
            productgstAmount: productgstAmount ? Number(productgstAmount).toFixed(2) : '0.00'
          });
        });

        totalbefortax = totalSum;
        totaldiscount = this.getTotaldiscount() || 0;
        totalafterdiscount = this.getTotalAmount() || 0;
        totaltax = this.getTotalGSTAmount() || 0;
        roundedamount = this.roundedamount || 0;
        totalamount = this.totalcredit() || 0;
      }

      const exportdata = {
        exportType: "pdf",
        expanded: "True",
        copy_key: copyKey,
        vendor_id: this.customer,
        voucher_type: selectedVoucher?.voucher_type || 'Sales',
        customerbranchgst: this.customer_branch_gst || selectedCustomerBranch?.gst_number || '',
        customerbranchname: selectedCustomerBranch?.branch_name || this.customer_branch_name || '',
        customerbranchaddress: selectedCustomerBranch?.address || selectedCustomerBranch?.billing_address || this.customer_branch_address || '',
        customerbranchaddress1: selectedCustomerBranch?.address1 || selectedCustomerBranch?.billing_address1 || this.customer_branch_address1 || '',
        customerbranchcity: selectedCustomerBranch?.city || selectedCustomerBranch?.billing_city || this.customer_branch_city || '',
        customerbranchpincode: selectedCustomerBranch?.pin_code || selectedCustomerBranch?.pincode || selectedCustomerBranch?.billing_pincode || this.customer_branch_pincode || '',
        customerbranchdistrict: selectedCustomerBranch?.district || selectedCustomerBranch?.billing_district || this.customer_branch_district || '',
        customerbranchstate: selectedCustomerBranch?.state_name || selectedCustomerBranch?.state || selectedCustomerBranch?.billing_state || this.customer_branch_state || '',
        customerbranchtan: selectedCustomerBranch?.tan_no || this.customer_branch_tan_no || '',
        customerbranchcin: selectedCustomerBranch?.cin_no || this.customer_branch_cin_no || '',
        vendorbranchgst: selectedBranch?.gst || '',
        vendorbranchname: selectedBranch?.branch_name || '',
        vendorbranchaddress: selectedBranch?.billing_address || selectedBranch?.address || '',
        vendorbranchaddress1: selectedBranch?.billing_address1 || selectedBranch?.address1 || '',
        vendorbranchcity: selectedBranch?.billing_city || selectedBranch?.city || '',
        vendorbranchpincode: selectedBranch?.billing_pincode || selectedBranch?.pin_code || '',
        vendorbranchdistrict: selectedBranch?.billing_district || selectedBranch?.district || '',
        vendorbranchstate: selectedBranch?.billing_state || selectedBranch?.state_name || '',
        vendorbranchtan: selectedBranch?.tan_no || '',
        vendorbranchcin: selectedBranch?.cin_no || '',
        companyname: this.company_name || '',
        companyphone: this.company_phone || '',
        companyemail: this.company_email || '',
        companyaddress: this.company_address || '',
        companygstno: this.company_gstno || '',
        companypan: this.company_pan || '',
        companycin: this.company_cin || '',
        companylogo: this.company_logo || '',
        companysignature: this.company_signature || '',
        voucher_id: this.data?.id || null,
        vouchernumber: this.document_no || '',
        doc_no: this.document_no || '',
        date: this.issue_date || '',
        data: resultArray,
        totalbefortax: parseFloat(totalbefortax.toFixed(2)),
        totaldiscount: parseFloat(totaldiscount.toFixed(2)),
        totalafterdiscount: parseFloat(totalafterdiscount.toFixed(2)),
        totaltax: parseFloat(totaltax.toFixed(2)),
        roundedamount: parseFloat(Number(roundedamount).toFixed(2)),
        totalamount: typeof totalamount === 'number' ? totalamount.toFixed(2) : totalamount,
      };

      console.log('PDF Export Payload:', exportdata);

      this.apiService.voucherpostingexport(exportdata).subscribe({
        next: (response: any) => {
          if (response && response[0]) {
            const downloadUrl = response[0];
            const filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);
            const downloadLink = document.createElement('a');
            downloadLink.href = downloadUrl;
            downloadLink.download = filename;
            downloadLink.target = '_blank';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          } else {
            console.error('No download URL returned from API');
          }
        },
        error: (error: any) => console.error('Error sending data:', error),
      });
    } catch (error) {
      console.error('Error in convertToPdf():', error);
    }
  }

  editHsnGst(productList: any[]) {
    const dialogRef = this.dialog.open(HsnGstEditComponent, {
      width: '1000px',
      height: '600px',
      data: {
        productList: productList,
        taxOptions: this.tax
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.productList = result;
      }
    });
  }

  removeFile(index: number) {
    this.myFiles.splice(index, 1);
    this.uploadedFiles.splice(index, 1);
  }

  openVoucherFileShowModal() {
    const finalId = this.data.id || this.originalVoucherId;
    if (finalId && this.voucherType) {
      this.apiService.getVoucherFiles(finalId, this.voucherType).subscribe(
        (response: any) => {
          if (response.status && response.uploadedFiles?.length > 0) {
            this.image_data = response.uploadedFiles;
            const modalRef = this.dialog.open(VoucherFileModalComponent, {
              width: '1200px',
              height: '600px',
              data: {
                id: finalId,
                images: this.image_data,
                voucherType: this.voucherType,
                isViewMode: this.isView
              }
            });

            modalRef.afterClosed().subscribe(result => {
              if (result?.remainingFiles) {
                this.existingFiles = result.remainingFiles;
                this.uploadedFiles = result.remainingFiles.map((file: any) => ({
                  ...file,
                  preview: `${this.fullhostname}/api/storage/${file.image}`,
                }));
                this.myFiles = [...this.uploadedFiles];
              }
            });
          } else {
            const modalRef = this.dialog.open(VoucherFileModalComponent, {
              width: '1200px',
              height: '600px',
              data: {
                id: finalId,
                images: [],
                voucherType: this.voucherType,
                isViewMode: this.isView
              }
            });
          }
        },
        (error) => {
          console.error("Error fetching voucher files:", error);
        }
      );
    } else {
      console.error("Invalid Voucher ID or Voucher Type ID.");
    }
  }
  canEditFromView(): boolean {
    const status = this.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  deleteVoucherFromView(): void {
    if (!this.canEditFromView() || !this.data?.id) return;
    if (!confirm('Are you sure you want to delete this voucher?')) return;
    const docType = this.voucherType || 'sales';

    const requestData = {
      doc_type: docType,
      doc_id: this.data.id,
      type: 'delete'
    };
    this.apiService.deleteVoucherPosting(this.data.id, requestData).subscribe(
      (response) => {
        if (response && response.message) {
          alert('Voucher removed successfully');
          this.dialogRef.close(true);
        }
      },
      (error) => {
        console.error('Error deleting voucher:', error);
        alert('Error deleting voucher');
      }
    );
  }
}
